module.exports = __webpack_public_path__ + "static/media/fernando.6006b8d6.jpg";